import { ButtonHTMLAttributes } from "react";

import { cn } from "../../../utils/cn";

const baseStyles = [
  "ring-0 outline-none cursor-pointer",
  "focus-visible:ring-[length:var(--button-ring-width-focus)] focus-visible:ring-button-ring-focus",
  "transition-all",
];

export interface UnstyledButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  "data-testid"?: string;
}

export function UnstyledButton({ className, ...rest }: UnstyledButtonProps) {
  return (
    <button type="button" className={cn(baseStyles, className)} {...rest} />
  );
}
